import { FC, memo } from 'react';
import Chart from 'react-apexcharts';

import { ApexChartProps } from './types';

const Component: FC<ApexChartProps> = memo((props) => {
    const { options, type = 'bar', series, width, height } = props;
    return <Chart options={options} type={type} series={series} width={width} height={height} />;
});
Component.displayName = 'ApexChart';

export const ApexChart: FC<ApexChartProps> = Object.assign(Component, {});
